import React from "react";
import {
    Table,
    TableBody,
    TablePagination,
    TableContainer,
} from "@mui/material";
import TableTop from "../TableTop/TableTop";
import { TableTopTypeEnum } from "../../../utils/enums/TableTopTypeEnum";
import {
    handleChangePage,
    handleChangeRowsPerPage,
} from "../../../../SharedComponents/utils/helpers/tableHelpers";
import UserAddressesTableHead from "../TableHeads/UserAddressesTableHead";
import UserAddressTableRow from "../TableRows/UserAddressesTableRow";

const UserAddressesTable = ({
    count,
    addresses,
    rowsPerPage,
    setRowsPerPage,
    page,
    setPage,
    onRowSelect,
    onDeleteAddress
}) => {
    return (
        <div >
            <TableTop count={count} variant={TableTopTypeEnum.TRANSPARENT} />
            <div style={styles.tablePaddingDiv}>
                <div style={styles.tableBorderDiv}>
                    <TableContainer style={styles.tableContainer}>
                        <Table style={styles.table}>
                            <UserAddressesTableHead />
                            <TableBody>
                                {addresses
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((address) => (
                                        <UserAddressTableRow
                                            key={address.address_id}
                                            address={address}
                                            onSelect={() => onRowSelect(address.address_id)}
                                            onDelete={(id) => onDeleteAddress(address.address_id)}
                                        />

                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(event, newPage) => {
                            handleChangePage(event, newPage, setPage);
                        }}
                        onRowsPerPageChange={(event) => {
                            handleChangeRowsPerPage(event, setRowsPerPage, setPage);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default UserAddressesTable;

const styles = {
    tablePaddingDiv: {
        padding: "40px",
    },
    tableBorderDiv: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        width: "60%",
        minHeight: "600px",
    },
    tableContainer: {
        width: "100%",
        minHeight: "500px",
    },
    table: {
        width: "100%",
        tableLayout: "fixed",
    },
};
